import configuration from './../config.json'
import CookieService from '../shared/services/cookiesService'

const SET_REPORTS_HISTORY = 'SET_REPORTS_HISTORY'
const SET_HISTORY_REPORT_READY = 'SET_HISTORY_REPORT_READY'
const SET_HISTORY_REPORT_NOT_READY = 'SET_HISTORY_REPORT_NOT_READY'
const CLEAR_REPORTS_HISTORY = 'CLEAR_REPORTS_HISTORY'

const setReportsHistoryAction = (data) => {
  return {
    type: SET_REPORTS_HISTORY,
    data
  }
}

const setReportsHistory = (data) => {
  return (dispatch) => {
    dispatch(setReportsHistoryAction(data))
  }
}

const clearReportsHistoryAction = () => {
  return {
    type: CLEAR_REPORTS_HISTORY
  }
}

const clearReportsHistory = () => {
  let authData = JSON.parse(CookieService.getCookie(configuration.cookieName))
  let email = authData.email
  let reportsHistory = JSON.parse(localStorage.getItem(configuration.reportsHistory))
  let userHistory = reportsHistory.find(item => item.email === email)
  userHistory.list = []
  
  localStorage.setItem(configuration.reportsHistory, JSON.stringify(reportsHistory))

  return (dispatch) => {
    dispatch(clearReportsHistoryAction())
  }
}

const setHistoryReportReadyAction = () => {
  return {
    type: SET_HISTORY_REPORT_READY
  }
}

const setHistoryReportReady = () => {
  return (dispatch) => {
    dispatch(setHistoryReportReadyAction())
  }
}

const setHistoryReportNotReadyAction = () => {
  return {
    type: SET_HISTORY_REPORT_NOT_READY
  }
}

const setHistoryReportNotReady = () => {
  return (dispatch) => {
    dispatch(setHistoryReportNotReadyAction())
  }
}

export {
  setReportsHistory,
  setReportsHistoryAction,
  SET_REPORTS_HISTORY,

  clearReportsHistory,
  clearReportsHistoryAction,
  CLEAR_REPORTS_HISTORY,

  setHistoryReportReady,
  setHistoryReportReadyAction,
  SET_HISTORY_REPORT_READY,

  setHistoryReportNotReady,
  setHistoryReportNotReadyAction,
  SET_HISTORY_REPORT_NOT_READY
}